import Api from "./api";
import uri from "urijs";
import {config} from "../src";
import N8nApi, {n8n} from "./n8n";

export default class WireframeApi extends Api {
	constructor(readonly n8n: N8nApi) {
		super(uri(config.kickoffUrl));
	}

	headers(): Record<string, string> {
		return this.n8n.headers();
	}

	async getWireframes(project: n8n.ProjektNr): Promise<string> {
		return await this.fetchJson('')
	}

	async saveWireframe(iframe: HTMLIFrameElement, wireframe: { project: string, variant: string }, mode: 'overwrite' | 'commit' = 'commit') {
		const html = iframe.contentDocument?.documentElement.outerHTML;

		const url = new URL(config.n8n["save-wireframe-webhook"]);

		url.searchParams.set('mode', mode);
		url.searchParams.set('project', wireframe.project);
		url.searchParams.set('variant', wireframe.variant);

		if (!html) return;

		return await this.fetchDirect(url, 'POST', {}, new Blob([html]))
			.then(res => res.json())
	}
}